const PALETTE = {
  mainColor: '#40A0FB',
  primary: {
    100: '#258EF7',
    200: '#047AF2',
    300: '#043EB2',
  },

  error: '#FF3636',

  white: '#FFFFFF',
  black: '#1F1F1F',
  gray: {
    0: '#F9F9F9',
    100: '#D9D9D9',
    200: '#898989',
  },
};

const FONT_SIZE = {
  es: '10px',
  xs: '12px',
  sm: '14px',
  md: '16px',
  em: '18px',
  big: '20px',
  lg: '24px',
  hg: '40px',
};

// font-weight
// 100 - Thin
// 200 - ExtraLight
// 300 - Light
// 400 - Regular
// 500 - Medium
// 600 - SemiBold
// 700 - Bold
// 800 - ExtraBold
// 900 - Black

const theme = {
  PALETTE,
  FONT_SIZE,
} as const;

export type Theme = typeof theme;
export default theme;
